import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../lib";
import { ApiEpSocialAccountConnectInstagramBusiness } from "./instagram_business";
import { ApiEpSocialAccountConnectYoutube } from "./youtube";
export class ApiEpSocialAccountConnect {
}
/**
 * Used to connect Account via Credential (id)
 */
ApiEpSocialAccountConnect.create = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/social-account/connect/${req.path.account_credential_id}`,
    method: "POST",
});
ApiEpSocialAccountConnect.InstagramBusiness = ApiEpSocialAccountConnectInstagramBusiness;
ApiEpSocialAccountConnect.Youtube = ApiEpSocialAccountConnectYoutube;
//# sourceMappingURL=connect.js.map